// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6319366f","902":"1ecceb88"}[chunkId] + ".chunk.js";
};